import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoggingMessageService } from 'src/app/services/logging-message.service';

@Component({
  standalone: true,
  selector: 'app-routing-error',
  templateUrl: './routing-error.component.html',
  styleUrls: ['./routing-error.component.scss']
})

export class RoutingErrorComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private logger: LoggingMessageService,) { }

  ngOnInit(): void {
    const linkId = this.route.snapshot.queryParams.linkid;
  }

}
